var ModalVideo = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

ModalVideo.prototype.init = function(){

  var self = this;

  // if there are any video elements present on the page
  if($(".has-video[data-video-files]").length) {

  	self.initVideoModals();

  }

  this.options.$el.find('.background-overlay').click(function() {
  	self.options.$el.removeClass('active').addClass('no-longer-shown');
  });

};

ModalVideo.prototype.initVideoModals = function(){

	var self = this;

	$(".has-video").on("click", function(e){

		var videoFilesJson = $(this).data('videoFiles');
		var videoFiles = videoFilesJson.videoFiles;

		// construct video DOM object
		var videoDom = '<video controls>';

		for (var i = 0; i < videoFiles.length; i++)
		{
			videoDom += '<source src="' + videoFiles[i].videoUrl +'" type="' + videoFiles[i].videoMimeType + '">';
		}

		videoDom += '</video>';

console.log(videoDom);

		self.options.$el.find('.video-wrapper').html(videoDom);

		$('[data-modal-video]').addClass('active').removeClass('no-longer-shown');

	});

};

module.exports = ModalVideo;
